import { useEffect, useState } from "react";
import useAuth from "../../../auth/useAuth";
import { useLocation } from "react-router-dom";
import { addCompanyToUserRoute, deleteCompanyToUserRoute } from "../../../config";
import { Alerts } from "../../../components/alerts/Alerts.tsx";
import { useCompanies } from "../companies/useCompanies.tsx";
import { useUserCompaniesDataById } from "./useUserCompaniesDataById.tsx";

export const useUserCompany = () => {

    const auth = useAuth();
    const token = auth.globals.token;
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const _id = query.get('id');
    const companies = auth.globals.companies;

    const [loadingRequest, setLoadingRequest] = useState(false);
    const [errorRequest, setErrorRequest] = useState(null);

    const [accessAllCompany, setAccessAllCompany] = useState(false);

    const [reloadData, setReloadData] = useState(false);
    const handleReloadData = () => {
        setReloadData(true);
    };

    const {
        alertSuccess,
        showErrorRequest,
    } = Alerts();

    useEffect(() => {
        if (reloadData) {
            handleReloadData();
            setReloadData(false);
            setAccessAllCompany(false);
            setInicitalValues({
                user: _id,
                companies: "",
                create_user: auth.globals.id.toString()
            })
        }
    }, [reloadData, auth.globals.id, _id]);

    const {
        companyListData,
        companyListError,
        companyListLoading
    } = useCompanies(reloadData);

    const {
        userCompanyListData,
        userCompanyListError,
        userCompanyListLoading
    } = useUserCompaniesDataById(reloadData, _id);

    const filterCompanyList = () => {
        const userCompanyIds = new Set(userCompanyListData.map(userCompany => userCompany.id));

        // Si el usuario logueado no tiene acceso a todas las empresas, restringir al listado permitido
        let baseList = companyListData;
        if (!accessAllCompany && Array.isArray(companies) && companies.length > 0) {
            const allowedIds = new Set(companies.map(Number));
            baseList = companyListData.filter((company: any) => allowedIds.has(company.id));
        }

        return baseList.filter((company: any) => !userCompanyIds.has(company.id));
    }

    useEffect(() => {
        if (Array.isArray(companies) && companies.length === 0) {
            setAccessAllCompany(true);
        } else {
            setAccessAllCompany(false);
        }
    }, [companies]);

    const filteredCompanyList = filterCompanyList();

    const [initialValues, setInicitalValues] = useState({
        user: _id,
        companies: "",
        create_user: auth.globals.id.toString()
    })

    const addCompanyToUser = async (body) => {
        try {
            let res = await addCompanyToUserRoute(token, body);
            let data = await res.json();
            if (data.error) {
                showErrorRequest(data.message, auth)
            } else if (res.ok) {
                setLoadingRequest(false)
                alertSuccess('Empresa Agregado', data.message, "/Users/Form?id=" + _id);
                setReloadData(true);
            } else {
                if (res.status === 401 || res.status === 403) {
                    showErrorRequest("No tiene autorización o su sesión ha expirado", auth);
                    setErrorRequest(null);
                }
                showErrorRequest(data.detail, auth);
                setErrorRequest(null);
            }
            setLoadingRequest(false)
            return data;
        } catch (errorRequest) {
            setLoadingRequest(false);
            setErrorRequest(errorRequest);
        }
    }

    const deleteUserCompany = async (id_companies, id_user) => {
        try {
            let res = await deleteCompanyToUserRoute(id_companies, id_user, token);
            let data = await res.json()
            if (data.error) {
                showErrorRequest(data.message, auth)
            } else if (res.ok) {
                setReloadData(true);
                try {
                    alertSuccess("Eliminar empresa asignada", "El acceso del usuario a la organización fue eliminado con éxito", undefined)
                } catch {
                }
            } else {
                if (res.status === 401 || res.status === 403) {
                    showErrorRequest("No tiene autorización o su sesión ha expirado", auth);
                    setErrorRequest(null)
                }
                showErrorRequest(data.detail, auth)
                setErrorRequest(data.detail)
            }
            setLoadingRequest(false)
            return data;
        } catch (errorRequest) {
            setLoadingRequest(false)
            setErrorRequest(errorRequest)
        }
    }

    const handleFormSubmit = (values) => {
        setInicitalValues(values)
        setLoadingRequest(true)
        addCompanyToUser(values)
    }

    const handleChangeAction = (values, target) => {
        values[target.name] = target.value.toString();
    }

    return {
        //properties
        loadingRequest,
        errorRequest,
        userCompanyListData,
        userCompanyListLoading,
        userCompanyListError,
        companyListLoading,
        companyListError,
        companyListData,
        filteredCompanyList,
        initialValues,
        accessAllCompany,

        //methods
        handleChangeAction,
        handleFormSubmit,
        deleteUserCompany,

    }
}